// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"IconLoading_loadingWrapper__F8bBM","loading":"IconLoading_loading__mYHcL","rotation":"IconLoading_rotation__2w25U"};